import { NgModule } from '@angular/core'
import { TooltipWhenEllipsisDirective } from './tooltip-when-ellipsis.directive'

@NgModule({
  declarations: [TooltipWhenEllipsisDirective],
  exports: [TooltipWhenEllipsisDirective]
})
export class TooltipWhenEllipsisModule {}
